/// <reference path="ChartSetupUI.js"/>
/// <reference path="../HTMLHelpers.js"/>
/// <reference path="../Constants.js"/>
/// <reference path="ChartSetupSelections.js" />

window.ChartSetupDataBinding = function () {
    var chartOptions, boundDataGroup, boundContentType, loaded;

    return {
        SortGroupedItems: function (items) {
            var b1 = [], b2 = [], i, all = [], indices = [];

            for (i = 0; i < items.length; i++)
                items[i].sortOrder > 0 ? b1.push(items[i]) : b2.push(items[i]);

            all = b1.sort(function (a, b) {
                return a.sortOrder - b.sortOrder;
            }).concat(b2);

            /* normalize sort orders for each position / axis*/
            for (i = 0; i < all.length; i++)
                all[i].sortOrder = indices[all[i].position] = (indices[all[i].position] || 0) + 1;

            return all;
        },

        GetBoundDataGroup: function () {
            if (boundDataGroup != undefined && boundDataGroup != null &&
                boundDataGroup.formattingRules != undefined && boundDataGroup.formattingRules != null) {
                for (var i = 0; i < boundDataGroup.formattingRules.length; i++) {
                    var rule = boundDataGroup.formattingRules[i];
                    if (typeof (rule.dateValue) == 'string') // convert string date value to Date
                        rule.dateValue = new Date(parseInt(rule.dateValue.match(/\d+/)[0], 10));
                }
            }

            return boundDataGroup;
        },
        GetBoundContentType: function () {
            return boundContentType;
        },
        GetGroupingByValue: function (grouping_val) {
            if (!boundDataGroup) return null;

            grouping_val = ('' + grouping_val).toLowerCase();
            var len = boundDataGroup.groupedItems.length;
            while (len--)
                if ((boundDataGroup.groupedItems[len].value + '').toLowerCase() == grouping_val)
                    return boundDataGroup.groupedItems[len];

            return null;
        },
        EnsureGroupingExists: function (groupItem) {
            if (!boundDataGroup) return null;
            var existingGrouping = this.GetGroupingByValue(groupItem.value);

            if (!existingGrouping) {
                // if dg was imported from template, use saved position
                if (boundDataGroup.templateGroupedItems && boundDataGroup.templateGroupedItems.length > 0) {
                    for (var i = 0; i < boundDataGroup.templateGroupedItems.length; i++)
                        if (boundDataGroup.templateGroupedItems[i].groupType == groupItem.groupType) {
                            groupItem.position = boundDataGroup.templateGroupedItems[i].position;
                            groupItem.sortOrder = boundDataGroup.templateGroupedItems[i].sortOrder;

                            // need to update items with correct sortOrder as well
                            var samePositionItems = $.grep(boundDataGroup.templateGroupedItems, function (item) {
                                return item.position == groupItem.position;
                            });
                            if (samePositionItems.length > 0)
                                for (var j = 0; j < boundDataGroup.groupedItems.length; j++)
                                    for (var tj = 0; tj < samePositionItems.length; tj++)
                                        if (boundDataGroup.groupedItems[j].position == groupItem.position &&
                                            boundDataGroup.groupedItems[j].value == samePositionItems[tj].value) {
                                            boundDataGroup.groupedItems[j].sortOrder = samePositionItems[tj].sortOrder;
                                        }
                            break;
                        }
                }
                boundDataGroup.groupedItems.push(existingGrouping = groupItem);
                boundDataGroup.groupedItems = this.SortGroupedItems(boundDataGroup.groupedItems);
                if (loaded)
                    Storyboard.FilterSort.updateSort(groupItem);
            }

            existingGrouping.text = existingGrouping.text || groupItem.text;
        },
        CheckIfGroupingExists: function (groupingValue) {
            var groupingExists = false;
            var grouping = this.GetGroupingByValue(groupingValue);

            if (grouping) {
                groupingExists = true;
            }

            return groupingExists;
        },
        AddGrouping: function (groupingItem) {
            boundDataGroup.groupedItems.push(groupingItem);
        },
        DeleteGroupingByValue: function (grouping_val) {
            if (!boundDataGroup) return null;

            grouping_val = ('' + grouping_val).toLowerCase();
            var len = boundDataGroup.groupedItems.length;
            while (len--)
                if (boundDataGroup.groupedItems[len].value.toString().toLowerCase() == grouping_val) {
                    var groupItem = boundDataGroup.groupedItems[len];
                    boundDataGroup.groupedItems.splice(len, 1);
                    Storyboard.FilterSort.updateSort(groupItem);
                }
        },
        BindTemplateData: function (templateData) {
            if (templateData.length === 0) {
                $('.dataSection').hide();
                $('#wizardChartVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
                return;
            }
            $("#templateQA").empty();
            $("#templateFilters").empty();
            $("#templateCalcType").empty();
            for (var i = 0; i < templateData.length; i++) {
                if (templateData[i].isWizard && !templateData[i].type.includes("dis")) {
                    if (templateData[i].type.includes("QnA") || templateData[i].type.includes("QA"))
                        $("#templateQA").append('<li>' + templateData[i].data + '</li>');
                    else if (templateData[i].type.includes("Filter"))
                        $("#templateFilters").append('<li>' + templateData[i].data + '</li>');
                    else if (templateData[i].type.includes("Calc"))
                        $("#templateCalcType").append('<li>' + templateData[i].data + '</li>');
                }
            }
        },
        SortGroupings: function () {
            if (boundDataGroup)
                boundDataGroup.groupedItems = this.SortGroupedItems(boundDataGroup.groupedItems);
        },
        BindAnswers: function (answers) {
            var answerArray = answers.filter(item => item.rowNo !== 999);
            var answerbox = $("#answerbox");
            var allItems = [];
            if (Storyboard.Constants.CalculationTypes.isAnswerBased($("#ddlCalculationType").val()) && answerArray.length > 0 &&
                $('#txtAnswer').val() == "")
                allItems.push({ answerId: "all", answerText: "--All--" });
            allItems = allItems.concat(answerArray);

            var extraAttributes = ["answerText", "rowNo"];
            var isCategoricalPercent = $("#ddlCalculationType").val() == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT;
            if (isCategoricalPercent)
                extraAttributes.push('excludeFromPercentage');

            HTMLHelpers.bindSelect(answerbox, allItems, 'answerId', 'answerText', false, false, false, false, extraAttributes);
            if ($("#chbShowAnswerId").is(":checked"))
                HTMLHelpers.resetOptionsTexts(answerbox, ["rowNo", "answerText"], " - ");

            if (isCategoricalPercent)
                answerbox.find('option[excludeFromPercentage="true"]').css({ 'font-style': 'italic', 'color': 'darkgray' });

            $("#answerboxInfo").toggle(isCategoricalPercent && answerArray.some(a => a.excludeFromPercentage));

            DataGroupSelections.RestoreSelectedAnswers(answerbox);
            if (HeatMapQuickSetup.isLoaded) {
                HeatMapQuickSetup.updateAnswersList(answerArray);
            } else {
                ChartSetupUI.updateGroupingsAvailabillity('answer', answerbox);
            }
        },
        BindSelectedAnswers: function (answers, selectedAnswers, calculationType) {
            var answerArray = answers.filter(item => item.rowNo !== 999);
            var allItems = [];
            if (Storyboard.Constants.CalculationTypes.isAnswerBased(calculationType) && answerArray.length > 0 &&
                $('#txtAnswer').val() == "")
                allItems.push({ answerId: "all", answerText: "--All--" });
            allItems = allItems.concat(answerArray);

            var extraAttributes = ["answerText", "rowNo"];
            var isCategoricalPercent = calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT
            if (isCategoricalPercent)
                extraAttributes.push('excludeFromPercentage');

            let $answerBox = $('#answerbox');
            HTMLHelpers.bindSelect($answerBox, allItems, 'answerId', 'answerText', false, false, false, false, extraAttributes);
            if ($("#chbShowAnswerId").is(":checked"))
                HTMLHelpers.resetOptionsTexts($answerBox, ["rowNo", "answerText"], " - ");

            if (isCategoricalPercent)
                $answerBox.find('option[excludeFromPercentage="true"]').css({ 'font-style': 'italic', 'color': 'darkgray' });

            $("#answerboxInfo").toggle(isCategoricalPercent && answerArray.some(a => a.excludeFromPercentage));

            DataGroupSelections.SetSelectedAnswers(selectedAnswers);
            if (HeatMapQuickSetup.isLoaded) HeatMapQuickSetup.updateAnswersList(answerArray);
        },
        BindCorrelationQuestions: function (questionArray) {
            HTMLHelpers.bindSelect($("#correlationQuestionBox"), questionArray, "questionId", "questionText");
            ChartSetupUI.disableForSelectedQuestions();
            if (boundDataGroup)
                DataGroupSelections.SetCorrelationSettings(boundDataGroup.correlationSettings);
        },
        BindQuestions: function (questionArray, refilterAnswers, selectedQuestions) {
            selectedQuestions = selectedQuestions ? selectedQuestions : ChartSetupUIObj.GetSelectedQuestions();
            var questionsText = [];

            var allItems = [];
            var qBlockEnabled = $("#chkQB").is(":checked");
            if (qBlockEnabled && $('#txtQuestion').val() == "")
                allItems.push({ questionId: "all", questionText: "--All--" });
            questionArray = allItems.concat(questionArray);

            for (var i in questionArray) {
                questionArray[i].aiIcon = questionArray[i].isAicompute ? Storyboard.Constants.aiIconEntity : '';
                questionArray[i].title = questionArray[i].questionText;
            }
            refilterAnswers = refilterAnswers != undefined ? refilterAnswers : true;
            HTMLHelpers.bindSelect(
                $('#questionBox'),
                questionArray,
                'questionId',
                'questionText',
                false, false, false, false,
                ["title", "code", "aiIcon", "questionText", "loopImportId", "isLoopIterator", "isHiddenLoopIterator", "isStacked", "isIndexed"],
                false,
                useNewLoopVisualization ? { id: "loopImportId", text: "loopName" } : null
            );

            if (useNewLoopVisualization)
                $('option[isHiddenLoopIterator="true"]', $('#questionBox')).addClass('hidden');

            if ($("#chbShowQuestionCode").is(":checked")) questionsText.push('code');
            questionsText.push('questionText');
            HTMLHelpers.resetOptionsTexts($("#questionBox"), questionsText, " - ");

            DataGroupSelections.SetSelectedQuestions(selectedQuestions);

            if (questionArray && (questionArray.length == 1 || refilterAnswers)) {
                ChartSetupDataCom.FilterAnswers();
            }

            if (HeatMapQuickSetup.isLoaded) {
                HeatMapQuickSetup.updateQuestionsList(questionArray);
            } else {
                ChartSetupUI.updateGroupingsAvailabillity('question', $('#questionBox'));
            }

            setTimeout(function () {
                ChartSetupUI.handleBaseSizeAnalysisDropdown()
            },0)
            
        },
        UpdateGroupings: function () {
            if (boundDataGroup)
                DataGroupSelections.SetDataGroupingSelections(boundDataGroup);
        },
        BindLoadedGroup: function (datagroup, contentType) {
            loaded = false;
            chartOptions = null;
            boundDataGroup = datagroup;
            boundContentType = contentType;
            this.SortGroupings();

            $("#chartPreview table").remove();
            $("#divChart").hide();
            $("#chbInvertChartPreview").removeAttr("checked").trigger("change");
            if (datagroup.isMain)
                Storyboard.LayoutDesigner.UserEvents.setChartEventsTabUI(datagroup.userEvents,
                    boundContentType == Storyboard.Constants.itemTypes.CHART ? $('#divChart')[0] : $('#divTable')[0]);

            if (datagroup.isMain)
                $("#dgVersion").val(datagroup.version);

            /* all datagroups requires a time period grouping item */
            var consts = Storyboard.Constants;
            var timeGrouping = consts.GroupTypes.getGroupItem(consts.GroupTypes.TIMEPERIOD_VAL, consts.Axis.axis, 0, '');
            this.EnsureGroupingExists(timeGrouping);

            DataGroupSelections.SetSelectedCalculationType(datagroup.calculationType, datagroup.numericPercentileValue, datagroup.isMain, datagroup.optionalChartSettings);

            DataGroupSelections.SetWeightSettings(datagroup.useWeight, datagroup.weightVariableId);

            /* applying question selections */
            DataGroupSelections.SetSelectedQuestions(datagroup.questionSelections.allQuestions ? "all" : datagroup.questionSelections.questions);
            DataGroupSelections.SetSelectedQuestionBlocks(datagroup.questionSelections.questionBlocks);
            DataGroupSelections.SetSelectedGridQuestions(datagroup.questionSelections.gridQuestions);
            DataGroupSelections.SetSelectedVariableSubsets(datagroup.questionSelections.variableSubsets);

            ChartSetupUI.updateGroupingsAvailabillity('question', $('#questionBox'));

            DataGroupSelections.SetCorrelationSettings(datagroup.correlationSettings);

            /* applying date and series settings */
            DataGroupSelections.SetSelectedTimeSettings(datagroup.timeSelections, datagroup.optionalFilterSettings);
            DataGroupSelections.SetSelectedSeriesSettings(datagroup.seriesSettings);
            DataGroupSelections.SetSelectedHeatmapSettings(datagroup.heatmapSettings);
            DataGroupSelections.SetGradientStops(datagroup.gradientStops);
            DataGroupSelections.SetTopValuesPerGroupNames(datagroup.seriesSettings.showTopValuesPerGroupNames, datagroup.seriesSettings.showTopValuesPerGroup);
            DataGroupSelections.SetSelectedSeriesStripSettings(datagroup.seriesSettings.seriesStripSettings, datagroup.isMain);
            DataGroupSelections.SetTextOptions(datagroup.textOptions, datagroup.customHeaders);
            DataGroupSelections.SetAxisOptions(datagroup, contentType);
            DataGroupSelections.SetDefaultAxisBehavior(datagroup);
            DataGroupSelections.SetCalculationOptions(datagroup);
            DataGroupSelections.SetChartOptions(datagroup);

            /* apply misc settings */
            DataGroupSelections.SetHFilterComparisonRules(datagroup);
            DataGroupSelections.SetSelectedFilters(datagroup.filters);
            DataGroupSelections.SetOptionalFilterSettings(datagroup);
            DataGroupSelections.SetDataGroupingSelections(datagroup);
            DataGroupSelections.SetBenchmarkOptions(datagroup);
            DataGroupSelections.SetTargetAreas(datagroup.targetAreas);
            DataGroupSelections.SetFormatRules(datagroup.formattingRulesIds);
            DataGroupSelections.SetSignificanceOptions(datagroup);
            DataGroupSelections.SetMeanSeriesSettings(datagroup.meanSeriesSettings);
            DataGroupSelections.SetPercentiles(datagroup);
            DataGroupSelections.SetRankSettings(datagroup.rankSettings);
            DataGroupSelections.SeAggregatedSeriesSettings(datagroup.aggregatedSeriesSettings);
            DataGroupSelections.SetReferenceDataSettings(datagroup.referenceDataSettings);
            DataGroupSelections.SetBaseInLoopedQuestionSettings(datagroup);

            ChartSetupUI.showHideRebaseSettingsBox();

            var runTopAfterMeanAggregate = (datagroup.meanSeriesSettings && datagroup.meanSeriesSettings.runBeforeTopByValue) ||
                (datagroup.aggregatedSeriesSettings && datagroup.aggregatedSeriesSettings.runBeforeTopByValue);
            $("#chbRunAfterMeanAggregate").attr("checked", runTopAfterMeanAggregate);
            ChartSetupUI.disableRunTopAfterMeanAggregate();

            if (datagroup.isMain)
                DataGroupSelections.SetTableLayoutSettings(datagroup);

            if (datagroup.exportAsScreenshot)
                $('#chbExportTableAsScreenshot').attr('checked', 'checked');
            else
                $('#chbExportTableAsScreenshot').removeAttr('checked');

            if (datagroup.allowExcelExport)
                $('#chbAllowExcelExport').attr('checked', 'checked');
            else
                $('#chbAllowExcelExport').removeAttr('checked');

            if (datagroup.allowCsvExport)
                $('#chbAllowCSVExport').attr('checked', 'checked');
            else
                $('#chbAllowCSVExport').removeAttr('checked');

            ChartSetupUI.showHideExcelExportAllRows();

            if (datagroup.nestFilterCompares)
                $('#chbNestCompareFilters').attr('checked', 'checked');
            else
                $('#chbNestCompareFilters').removeAttr('checked');

            if (!datagroup.isMain && datagroup.overrideMainFormatRules)
                $("#chkUseMainFormattingRules").removeAttr("checked");
            else
                $("#chkUseMainFormattingRules").attr('checked', 'checked');

            if (datagroup.sortingInfo.enableColumnSort)
                $("#chbEnableColumnSort").attr("checked", "checked");
            else
                $("#chbEnableColumnSort").removeAttr("checked");

            $('#chbExportToEditablePPTAsImage').attr('checked', datagroup.exportToEditablePptAsImage);

            ChartSetupUI.updateCompareFilterWeightSelections();
            ChartSetupUI.hideFormatRulesBtn();
            ChartSetupUI.showHideExportAsImage();

            DataGroupSelections.SetThreshold(datagroup);

            // Get cached chartstyles and set control values on tab "Layout"
            var curEditItemGuid = $('.layoutElementAdminFocused').attr('guid');
            var cachedStyles = Storyboard.DataGroupLogic.GetChartStyleCacheWithGuid(curEditItemGuid) || {};

            DataGroupSelections.SetChartStyles(cachedStyles);

            loaded = true;
            ChartSetupDataBinding.UpdateGroupings();

            /* needs to be applied last because it's actually doing an ajax request based on gui selections */
            Storyboard.FilterSort.setSelections(datagroup, true);

            DataGroupSelections.InitializeAxisAndLegendListBox();

            if (datagroup.seriesSettings.seriesType == Storyboard.Constants.SeriesTypes.SCATTER || datagroup.seriesSettings.seriesType == Storyboard.Constants.SeriesTypes.BUBBLE) {
                $("#chartstyle_series_marker_enabled").attr("checked", "checked");
            }
            $('#setupChart .dataGroupsSelections .linkButton').removeAttr('disabled');
            Storyboard.LayoutDesigner.UserEvents.showMarkersMessage(contentType == Storyboard.Constants.itemTypes.CHART);
        },
        BindFilters: function (filterArray) {
            Storyboard.GuiEvents.bindFilters(filterArray, "filterBox", "filterboxTemplate", true);
            Storyboard.GuiEvents.bindOptionalFilters(filterArray, "optionalFilterBox", "optionFilterTemplate", "optionalFilterSettings");
            Storyboard.GuiEvents.bindOptionalFiltersCheckAll("optionalFilterBox");
            Storyboard.RespondentTableCache.setVariableToCache(filterArray, 'filterArray');
        },
        BindRankOptionalFilterItems: function (rankItems) {
            HTMLHelpers.bindSelect('#ddlRankOptionalFilter', rankItems, 'value', 'text', null, true);
            $(".rankOptionalFilterCheckbox, .ddlRankOptionalFilter").css("display", rankItems.length < 1 ? "none" : "");
        },
        BindHFilters: function () {
            //not zero since it is selected group
            if ($("#hFilterComparisonLevels option").length < 1)
                for (var i = 0; i <= 15; i++)
                    $("#hFilterComparisonLevels").append("<option value='" + i.toString() + "'>" + i.toString() + "</option>");

        },
        BindThemesList: function (themeArray) {
            for (var index in themeArray)
                if (themeArray.hasOwnProperty(index) && themeArray[index].themeID != 10) { // exclude chart creator theme

                    var theme = $('<div class="ThemePreview"><img src="' + Storyboard.Constants.chartTemplateImageFolderPath + themeArray[index].themeID + '.png" alt="' + themeArray[index].themeName + '" title="' + themeArray[index].themeName + '" themeID="' + themeArray[index].themeID + '" /></div>')
                        .click(function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            Storyboard.LayoutControls.showLoadingBar('Applying template style...');
                            Storyboard.HighchartsWrapper.resetChartStyleControls();
                            var curEditItemGuid = $('.layoutElementAdminFocused').attr('guid');
                            ChartSetupProxy.GetThemeStyles($(evt.target).attr('themeID'), function (styles) {
                                DataGroupSelections.OverrideSpecificThemeStyles(styles);
                                DataGroupSelections.SetChartStyles(styles);
                                if (Storyboard.GuiEvents?.DataGroupEdit?.setChartStyleCacheWithGuid) {
                                    Storyboard.GuiEvents.DataGroupEdit.setChartStyleCacheWithGuid(styles, curEditItemGuid);
                                }
                                Storyboard.LayoutControls.hideLoadingBar();
                            });
                        });
                    $('#ChartThemesTemplateList').append(theme);
                }
        },
        RenderChartData: function (chartData, itemType) {

            //logic to set up rendering of charts, not needed for simple table
            if (itemType == Storyboard.Constants.itemTypes.CHART) {
                ChartSetupDataCom.GetChartData(chartData);
                chartOptions = chartData.chartOptions;
                var chartDiv = '#divChart';
                if (chartData.customMessage && chartData.customMessage.length > 0) {
                    $(chartDiv).children().remove();
                    $(chartDiv).html(
                        $('<div/>', {
                            class: 'layoutElementCustomMessage',
                            html: $('<span/>', {
                                class: 'customMessage',
                                text: locale.get(chartData.customMessage)
                            })
                        })
                    );
                    $(chartDiv).show();
                } else if (chartData.chartOptions == 'nodata') {
                    $(chartDiv).children().remove();
                    $(chartDiv).addClass("layoutElementNoData");
                    $(chartDiv).show();
                } else {
                    $(chartDiv).removeClass("layoutElementNoData layoutElementCustomMessage");

                    /* stuff needs to be visible in order for correct measuring in chart!! */
                    $(chartDiv).show();
                    $('.showDivTable, .invertBackground').show();
                    ChartSetupDataBinding.RedrawChart();
                }
            }
            else if (itemType == Storyboard.Constants.itemTypes.HEATMAP) {
                var hmDiv = "#divChart";
                if (chartData.heatMapOptions == null || chartData.heatMapOptions.dataSet == null) {
                    $(hmDiv).children().remove();
                    $(hmDiv).addClass("layoutElementNoData");
                    $(hmDiv).show();
                }
                else {
                    $(hmDiv).removeClass("layoutElementNoData");

                    /* stuff needs to be visible in order for correct measuring in chart!! */
                    $(hmDiv).show();
                    $('.showDivTable').show();
                    HeatMapRenderer.renderHeatMap(hmDiv, chartData);
                }
            }

            //table should always be rendered though, regardless of item type
            $('#divTable').empty();

            if (chartData.tableCss)
                $('<style>').text(chartData.tableCss).appendTo($('#divTable'));
            $("#divTable").append(chartData.tableHtml);

            if (itemType == Storyboard.Constants.itemTypes.SIMPLETABLE && $("table td[sortKey]", $("#divTable")).length > 0) {
                $("table td[sortKey]", $("#divTable")).addClass("stSortableColumn");

                $(".stSortableColumn", $("#divTable")).unbind("click").bind("click", function () {
                    var newSortDirection = $(this).attr("sortDirection") == "desc" ? 8 : 9; // 8 - ascending, 9 - descending
                    $("#divTable td.stSortableColumn").removeAttr("sortDirection");
                    $(this).attr("sortDirection", newSortDirection);

                    $("#btnUpdateChart").click();
                });
            }

            if (itemType != Storyboard.Constants.itemTypes.CHART && itemType != Storyboard.Constants.itemTypes.HEATMAP) {
                $("#divTable").slideDown('fast');
                $('.invertBackground').show();
            }
        },
        RedrawChart: function () {
            if (!chartOptions)
                return;

            var dataGroup = ChartSetupUIObj.GetDatagroupFromGui();

            if (dataGroup.chartOptions.allowChartZoom)
                chartOptions.chart.zoomType = 'xy';
            else
                chartOptions.chart.zoomType = '';

            chartOptions.chart.guid = 'preview';
            var styles = ChartSetupUIObj.GetChartStyles();
            Storyboard.HighchartsWrapper.produceChart('divChart', chartOptions, null, null, null, styles, dataGroup.userEvents);
        },
        FiltersLoaded: false
    };
}();
